export default __webpack_public_path__ + "static/media/CHU6721.dee8820d.jpg";